import ApiService from "@/common/api.service";

const PATH = "stock/warehouses";

export const GET_STOCK_WAREHOUSES = "getStockWarehouses";
export const GET_STOCK_WAREHOUSE_OPTIONS = "getStockWarehouseOptions";
export const GET_STOCK_WAREHOUSE = "getStockWarehouse";
export const CREATE_STOCK_WAREHOUSE = "createStockWarehouse";
export const UPDATE_STOCK_WAREHOUSE = "updateStockWarehouse";
export const DELETE_STOCK_WAREHOUSE = "deleteStockWarehouse";
export const ASSIGN_STOCK_WAREHOUSE_USERS = "assignStockWarehouseUsers";

const state = {};

const getters = {};

const actions = {
  [GET_STOCK_WAREHOUSES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_STOCK_WAREHOUSE_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_STOCK_WAREHOUSE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [CREATE_STOCK_WAREHOUSE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [UPDATE_STOCK_WAREHOUSE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [ASSIGN_STOCK_WAREHOUSE_USERS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, `${payload.id}/users`, payload.params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [DELETE_STOCK_WAREHOUSE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${id}`)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data || error);
        });
    });
  },
};

const mutations = {};

export default {
  state,
  actions,
  mutations,
  getters,
};
